import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-161b6b12"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"demo-1-hero\" data-v-161b6b12><div class=\"container\" data-v-161b6b12><div class=\"row vcenter\" data-v-161b6b12><div class=\"col-lg-12\" data-v-161b6b12><div class=\"hero-content\" data-v-161b6b12><div data-delay=\"40\" style=\"font-size:28px;line-height:normal;\" data-v-161b6b12><span style=\"font-size:36px;font-weight:bold;\" data-v-161b6b12>ADVANCED Writer</span> <span style=\"font-size:28px;font-weight:normal;\" data-v-161b6b12>-- An AI agent designed to assist in the standardization of manuscript reporting and facilitate rapid evaluation</span></div><p class=\"mt20\" data-delay=\"600\" style=\"font-size:18px;\" data-v-161b6b12> 妙笔 -- 帮助作者撰写更加完整、规范和清晰的文章，协助编辑和审稿人快速确定文章的报告质量，指出报告存在的问题 </p></div></div></div></div></section>", 1)
const _hoisted_2 = {
  class: "sec-pad position-relative",
  style: {"margin-bottom":"50px","padding-bottom":"30px"}
}
const _hoisted_3 = { class: "container index-up" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-12" }
const _hoisted_6 = { class: "contactusblockpair-1 shadow roundimg" }
const _hoisted_7 = {
  class: "formblockz",
  style: {"background":"white"}
}
const _hoisted_8 = { class: "form-block rundalform" }
const _hoisted_9 = {
  key: 0,
  src: "/statics/images/pdf@2x.png",
  style: {"width":"58px","height":"58px","margin-top":"10px"}
}
const _hoisted_10 = {
  key: 1,
  src: "/statics/images/doc@2x.png",
  style: {"width":"58px","height":"58px","margin-top":"10px"}
}
const _hoisted_11 = {
  key: 2,
  src: "/statics/images/upload@2x.png",
  style: {"width":"78px","height":"66px"}
}
const _hoisted_12 = {
  key: 3,
  class: "el-upload__text"
}
const _hoisted_13 = {
  key: 4,
  class: "el-upload__text"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "click to upload", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","color":"#8C919C"} }, "support WORD and PDF", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { id: "filelist" }, null, -1))
const _hoisted_17 = {
  class: "",
  style: {"margin-top":"20px","text-align":"left","display":"flex","justify-content":"space-between","align-items":"center"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px","color":"#515862","margin-right":"10px"} }, "Checklist:", -1))
const _hoisted_19 = {
  class: "infoblockz sw-bg-3-wave",
  style: {"background":"white","margin-top":"25px"}
}
const _hoisted_20 = {
  key: 0,
  class: "contactinfodivv"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/statics/images/empty@2x.png",
  style: {"height":"220px","width":"240px"}
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "contactinfodivv",
  style: {"display":"flex","flex-wrap":"wrap","width":"100%"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/statics/images/more.png",
  style: {"width":"16px","height":"16px","top":"-1px","position":"relative"}
}, null, -1))
const _hoisted_25 = {
  class: "con-block-sw-div",
  style: {"min-height":"100px","width":"100%"}
}
const _hoisted_26 = { style: {"display":"flex"} }
const _hoisted_27 = { style: {"display":"flex"} }
const _hoisted_28 = { style: {"display":"flex"} }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = { key: 4 }

import { ref,toRaw,reactive, onMounted, watch, onBeforeUnmount} from 'vue';
  import { useRouter } from 'vue-router';
  import { genFileId ,ElMessage,ElLoading} from 'element-plus';
  import type { UploadFile, UploadInstance, UploadProps, UploadRawFile,ElProgress } from 'element-plus';
  import { checkListGetall, getProgress, judgeChecklist} from "../api/modules/api.checklist";
  import {getList,create,downloadExcel} from "../api/modules/api.upload";
  import {authIsLogin} from '../api/modules/api.auth.js';
  import dbUtils from '../libs/util.strotage.js'
  
  const __default__ = {
    name: 'CheckListView',
  };
  
  
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  const promptsValue = ref('')
  const llmValue = ref('')
  const promptsOptions = ref([])
  const llmOptions = ref([{value:'gpt-4o',label:'gpt-4o'},{value:'gpt-4-0125-preview',label:'gpt-4-0125-preview'},{value:'gpt-4-1106-preview',label:'gpt-4-1106-preview'},{value:'gpt-3.5-turbo-0125',label:'gpt-3.5-turbo-0125'},
  {value:'gpt-3.5-turbo-1106',label:'gpt-3.5-turbo-1106'},{value:'claude-3-opus-20240229',label:'claude-3-opus-20240229'},
  {value:'claude-3-sonnet-20240229',label:'claude-3-sonnet-20240229'}
  ])

    const tableData = ref([]);
    const total = ref(0);
    const pageSize = ref(5);
    const currentPage = ref(1);
    const router = useRouter();
    const userInfo = dbUtils.get('FrontuserInfo')
   
    let uploadsIds = dbUtils.get("UploadsIds")
    const ifLogin = ()=>{
        authIsLogin().then(res => {
            console.log(res)
            if(!res.data){
                dbUtils.remove("FrontuserInfo") //去掉登录信息
            }
            fetchData();
        })
    }
    
    const fetchData = async (page = 1) => {
        try {
            

            let p = {
                pagination:{"current":page,
                            "pageSize":pageSize.value
                }
            }
            if(!userInfo){
                p["params"] = {}
                p["params"]["id"] = [null]
                if(uploadsIds){
                    p["params"]["id"] = uploadsIds.slice(0,10) //最多10个
                }
                

            }
            getList(p).then(res => {
                state.loading.spinning = false
                let datas = res.data.result
                
                tableData.value = datas
                total.value = res.data.total
                state.query.pagination.current = res.data.current
                state.query.pagination.pageSize = res.data.pageSize
            }).catch(err => {
                state.loading.spinning = false
                console.log(err)
            })
        
       
        } catch (error) {
        ElMessage.error('获取数据失败');
        }
    };
    const get_progress = ()=>{
        getProgress().then(res => {
            const keys1 = Object.keys(state.progressData);
            const keys2 = Object.keys(res.data);
            if(JSON.stringify(keys1) !== JSON.stringify(keys2)){
                fetchData(currentPage.value);
            }
            state.progressData = res.data
        })
    };
    const state = reactive({
      progressData:{},
      show: {
        add: false,
        edit: false,
        view: false
      },
      activeComponent: null,
      // 暂存更新数据
      updateData: {},
      // 暂存查看数据
      viewData: {},
      dataList: [],
      // 请求参数
      query: {
        params: {},
        pagination: {
          current: 1,
          pageSize: 5,
          total: 0,
          hideOnSinglePage: true,
        },
        sort: {
          columnKey: "createdAt",
          order: "ascend"
        }
      },
      // loading
      loading: {
        spinning: false,
        tip: '加载中'
      }
    })
    let timer
    let timer2
    const fileName = ref('')
    const upload = ref<UploadInstance>()
    const fileUp = ref()
    const handleExceed: UploadProps['onExceed'] = (files) => {
    upload.value!.clearFiles()
    const file = files[0] as UploadRawFile
    
    file.uid = genFileId()
    upload.value!.handleStart(file)
    fileName.value = file.name
    
  }
  const moreClick = ()=>{
     //router.push('/uploadsList'); // 使用 push 跳转
     //router.push({ name: 'Detail', params: { id: items.id } });
     const url = `/uploadsList`;
     window.open(url, '_blank');
  }
  const handleCurrentChange = (page) => {
      currentPage.value = page;
      fetchData(page);
    };

  const handleDown = (item,item2)=>{
    try {
        let p = {
            "id":item2.id,
            
        }
        downloadExcel(p).then(res => {
                 
        }).catch(err => {
           
            console.log(err)
            ElMessage.error('下载失败'+err.message);
        })
    
    
    } catch (error) {
        ElMessage.error('下载失败'+error.message);
    }

  }  
  const gotoDetail = (item, items)=>{
    //router.push({ name: 'Detail', params: { id: items.id } });
    const url = `/detail/${items.id}`;
    window.open(url, '_blank');
  }


  const handleSuccess = (uploadFile: UploadFile) => {
    console.log("fsadjisajdisajdias")
    console.log(uploadFile)
  }
  const handleChange = (uploadFile: UploadFile) => {
    if(uploadFile.status === 'ready'){
        return;
    }
  // 设置input框的值为上传文件的名称
    fileName.value = uploadFile.name
    console.log("the file is")
    console.log(uploadFile)
    console.log(uploadFile.name)
    

    fileUp.value = uploadFile.raw
    var data = new FormData();
    data.append("file", fileUp.value, fileName.value);
    
    const loading = ElLoading.service({
        lock: true,
        text: 'Loading', 
    })
    judgeChecklist(data).then(res => {
       console.log(res);
       const categoryValue = res.data?.category;
        if (categoryValue) {
            console.log("Category exists:", categoryValue);
            
            promptsOptions.value.forEach((element) => {
                if (element.label === categoryValue) {
                    promptsValue.value = element.value;
                }
            });
        } 
       
       loading.close()
 
    }).catch(err => {
        loading.close()
        console.log(err);
    })



  }
  const getDataList = () => {
      state.loading.spinning = true
      // 将响应式query返回起原始对象
      let p = toRaw(state.query)
  
      checkListGetall(p).then(res => {
        state.loading.spinning = false
       
        let promptsList = []; 
        for(let item of res.data.result){
            promptsList.push({value:item.id,label:item.name});
        }
        promptsOptions.value = promptsList;
      }).catch(err => {
        state.loading.spinning = false
        console.log(err)
      })
  
    }
  const submitUpload = () => {
    console.log("begin to upload");
    
    if(promptsValue.value==""){
        ElMessage.error('请选择清单');
        return;
    }
    console.log(fileUp.value)
    console.log(fileName.value)
    if(!fileUp.value){
        ElMessage.error('请选择文件');
        return;
    }
    const loading = ElLoading.service({
        lock: true,
        text: 'Loading', 
    })
    // if(llmValue.value==""){
    //     ElMessage.error('请选择模型');
    //     return;
    // }
    //upload.value!.submit()
    var data = new FormData();
    data.append("file", fileUp.value, fileName.value);
    data.append("promptId", promptsValue.value);
    data.append("llm", llmValue.value);
    fileUp.value="";
    fileName.value="";
    create(data).then(res => {
        console.log(res);
        if(!uploadsIds){
            uploadsIds = []
        }
        uploadsIds.push(res.data)
        dbUtils.set("UploadsIds", uploadsIds)
        fetchData();
       
        loading.close()
 
    }).catch(err => {
        loading.close()
        console.log(err);
    })
  }
    const startRefreshing = () => {
        getDataList(); // 初始化时先获取一次数据
        timer = setInterval(() => {
            fetchData(currentPage.value);
        }, 1000*60); // 每 60 秒刷新一次
        timer2 = setInterval(() => {
            get_progress()
        }, 1000*10); // 每 10 秒刷新一次
    };

    const stopRefreshing = () => {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
       
        if(timer2){
            clearInterval(timer2);
            timer2 = null;
        }
    };
    //getDataList();

    // 监听selectedValue的变化并更新localStorage
    watch(promptsValue, (newValue) => {
        localStorage.setItem('promptsValue', newValue);
    });
    watch(llmValue, (newValue) => {
        localStorage.setItem('llmValue', newValue);
    });
    // 当组件挂载时，尝试从localStorage读取保存的选择值
    onMounted(() => {
        const savedValue = localStorage.getItem('promptsValue');
        if (savedValue) {
            promptsValue.value = savedValue;
        }
        const savedTwoValue = localStorage.getItem('llmValue');
        if (savedTwoValue) {
            llmValue.value = savedTwoValue;
        }
        ifLogin();
        
        startRefreshing();
    });
    onBeforeUnmount(() => {
      stopRefreshing();
    });

  
return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_upload, {
                    class: "upload-demo",
                    style: {"height":"150px"},
                    drag: "",
                    "on-change": handleChange,
                    "on-exceed": handleExceed,
                    "show-file-list": false,
                    accept: ".docx,.pdf"
                  }, {
                    default: _withCtx(() => [
                      (fileUp.value && fileUp.value.type === 'application/pdf')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                        : (fileUp.value && fileUp.value.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                          : (_openBlock(), _createElementBlock("img", _hoisted_11)),
                      (fileUp.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(fileUp.value.name), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createTextVNode(" Drop file here or "),
                            _hoisted_14,
                            _hoisted_15
                          ]))
                    ]),
                    _: 1
                  }),
                  _hoisted_16
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_el_select, {
                    modelValue: promptsValue.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((promptsValue).value = $event)),
                    filterable: "",
                    placeholder: "Please select a checklist",
                    style: {"width":"314px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promptsOptions.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    class: "ml-3",
                    type: "success",
                    onClick: submitUpload,
                    style: {"background":"#3E959B","border-radius":"20px 20px 20px 20px","right":"40px","height":"36px","margin-left":"auto","width":"370px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Run ")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                (tableData.value.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("div", {
                        style: {"margin-left":"auto","color":"#04A3AE","font-size":"14px","cursor":"pointer","margin-bottom":"5px"},
                        onClick: moreClick
                      }, [
                        _createTextVNode("more"),
                        _hoisted_24
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_table, {
                            data: tableData.value,
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "filename",
                                label: "File Name"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "promptInfo.name",
                                label: "Checklist",
                                width: "120"
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "Uploaded time",
                                width: "180"
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("span", null, _toDisplayString(new Date(scope.row.createdAt).toLocaleString()), 1)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "Finished time",
                                width: "180"
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("span", null, _toDisplayString(new Date(scope.row.updatedAt).toLocaleString()), 1)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "Status",
                                width: "120"
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_28, [
                                    (state.progressData[scope.row.id])
                                      ? (_openBlock(), _createBlock(_component_el_progress, {
                                          key: 0,
                                          type: "circle",
                                          width: "45",
                                          percentage: state.progressData[scope.row.id],
                                          "stroke-width": 6
                                        }, null, 8, ["percentage"]))
                                      : (scope.row.status === '4')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, " Pending"))
                                        : (scope.row.status === '1')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, " Pending"))
                                          : (scope.row.status === '2')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, " Completed"))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_32, "Error"))
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "Operation",
                                width: "120"
                              }, {
                                default: _withCtx((scope) => [
                                  _createVNode(_component_el_button, {
                                    link: "",
                                    size: "small",
                                    style: _normalizeStyle({
                                                    border: 0, 
                                                    color: scope.row.status === '2' ? '#04A3AE' : '#B0B0B0', 
                                                    cursor: scope.row.status === '2' ? 'pointer' : 'not-allowed'
                                                }),
                                    disabled: scope.row.status !== '2',
                                    onClick: ($event: any) => (gotoDetail(scope.$index, scope.row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Detail ")
                                    ]),
                                    _: 2
                                  }, 1032, ["style", "disabled", "onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data"])
                        ])
                      ])
                    ]))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})